import _ from 'lodash'

export const state = () => ({
  // list of available subevents for the event
  subevents: [],
  mainSubevent: null,
  // list of guests
  guests: [],
  // list of subevents users have rsvp-ed
  rsvpEevents: [],
  // list of subevent ids guests have access to
  guestsAccessEvents: []
})

export const getters = {

}

export const mutations = {
  setGuestList (state, data) {
    state.guests = data
  },
  setSubeventsList (state, data) {
    state.subevents = data
  },
  setMainSubevent (state, data) {
    state.mainSubevent = data
  },
  setRsvpEventsList (state, data) {
    state.rsvpEevents = data
  },
  setGuestsAccessEventsList (state, data) {
    state.guestsAccessEvents = data
  }
}

export const actions = {
  async fetchSubeventsList ({ dispatch, rootState, commit }, { $axios, requestData }) {
    if (rootState?.user?.session?.is_event_admin !== undefined && rootState.user.session.is_event_admin === true) {
      requestData.mode = 'admin'
    }
    if (rootState?.user?.session?.is_event_admin !== undefined && rootState?.user?.session?.is_event_admin === true) {
      requestData.uid = rootState.user.session.uid
    } else if (rootState?.user?.session?.guid !== undefined && rootState.user.session.guid !== null) {
      requestData.guest_id = rootState.user.session.guid
    }

    try {
      const { data } = await $axios.post('/api/v1/event/get_subevents', requestData)
      if (data.status === 200) {
        commit('setSubeventsList', data.subevents) // local mutation
      }
    } catch (error) {
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },
  async fetchGuestList ({ dispatch, rootState, commit }, { $axios, requestData }) {
    try {
      const { data: guestListData } = await $axios.post('/api/v1/feonly/get_guest_list', requestData)

      let data = guestListData.data;
      if (guestListData.status === 200) {
        let flatContacts = [];
        let guestsAccessEvents = [];
        // uid is inferred from logged in cookie session
        const { data: rsvpData } = await $axios.post('/api/v1/editor/rsvp_subevent_guests', {'event_id': requestData.event_id})
        let tGuestRsvp = {}
        if (rsvpData?.subevents !== undefined) {
          commit('setRsvpEventsList', rsvpData.subevents ) // local mutation
          // lets populate rsvp answers
          for (let subIndex in rsvpData.subevents) {
            if (typeof rsvpData.subevents[subIndex].rsvp === 'object' && _.size(rsvpData.subevents[subIndex].rsvp)) {
              _.forOwn (rsvpData.subevents[subIndex].rsvp, (groupVals,groupKey) => {
                _.forOwn (groupVals, (guestVals, guestKey) =>  {
                  if (typeof tGuestRsvp[guestKey] === 'undefined') {
                    tGuestRsvp[guestKey] = {};
                  }
                  tGuestRsvp[guestKey][subIndex] = {attend: guestVals.attend}
                })
              })
            }
          }
        }

        for (let groupIndex in data.groups) {
          // if (groupIndex !== 'UNGROUPED') {
          if (data?.groups[groupIndex]?.guests !== undefined) {
            flatContacts = flatContacts.concat(data.groups[groupIndex].guests);
            for (let guestIndex in data.groups[groupIndex].guests) {
              guestsAccessEvents = _.union(guestsAccessEvents, data.groups[groupIndex].guests[guestIndex].se_access)
            }
          }

          // }
          // else {
          //   flatContacts = flatContacts.concat(data.groups[groupIndex].guests);
          //   guestsAccessEvents = _.union(guestsAccessEvents, data.groups[groupIndex].se_access)
          // }
        }
        if (typeof tGuestRsvp !== 'undefined') {

          //console.log(flatContacts);
          for (let flatGuestIndex in flatContacts) {
            //console.log(flatContacts[flatGuestIndex]);
            flatContacts[flatGuestIndex].attendByEvent = {};
            if (typeof tGuestRsvp[flatContacts[flatGuestIndex].guest_id] !== 'undefined') {
              flatContacts[flatGuestIndex].attendByEvent = tGuestRsvp[flatContacts[flatGuestIndex].guest_id]
            }
          }
        }
        // console.log(guestsAccessEvents.length, flatContacts.length)
        commit('setGuestList', flatContacts) // local mutation
        commit('setGuestsAccessEventsList', guestsAccessEvents) // local mutation
      }
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async modifyGuest ({ dispatch, rootState, commit, state }, { $axios, requestData }) {
    try {
      const { data } = await $axios.post('/api/v1/guestlist/modify_guest', requestData)
      if (data.status === 200) {
        // now that we have saved it let's fetch all the guests
        dispatch('fetchGuestList', {$axios: $axios, requestData: {'event_id': rootState.user.session.selected_event}})
      }
    } catch (error) {
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  }
}
